import type { ProjectState } from 'app/store/project/project.state';
import { createSelector } from '@ngrx/store';
import { selectProjectState } from 'app/store/project/project.state';
import * as fromPageCriteriaState from './page-criteria.reducer';

export const pageCriteria = createSelector(
  selectProjectState,
  (state: ProjectState, key: string) => fromPageCriteriaState.selectEntities(state.pageCriteria)[key],
);
